/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from './TextInput';
import { useValidationMessagingArgs, ValidationStates } from './ValidationMessages';

interface FirstNameProps {
    initialValue?: string;
}

const verification: useValidationMessagingArgs = {
    applicableStates: [ValidationStates.MissingRequired],
};

export const FirstName: React.FC<FirstNameProps> = ({ initialValue }) => {
    const { t } = useTranslation(['common']);

    return (
        <TextInput
            formFieldId="FirstName"
            isRequired
            inputValidation={verification}
            label={t('common:firstName')}
            name="FirstName"
            initialValue={initialValue}
        />
    );
};
